import { render, staticRenderFns } from "./GatewayDetailBreakdown.vue?vue&type=template&id=763c6fbe&scoped=true&lang=html&"
import script from "./GatewayDetailBreakdown.vue?vue&type=script&lang=ts&"
export * from "./GatewayDetailBreakdown.vue?vue&type=script&lang=ts&"
import style0 from "./GatewayDetailBreakdown.vue?vue&type=style&index=0&id=763c6fbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763c6fbe",
  null
  
)

export default component.exports